/*
 * @Author: Teemo Ding
 * @Date: 2022-05-05 13:23:09
 * @LastEditTime: 2022-06-06 16:15:21
 * @LastEditors: Json Chen
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Analytics/ReportSubscription/Components/SelectWithDelete/index.tsx
 */
import { Select } from '@/src/components/Antd';
import { Icon } from '@/src/tools/icon';
import React from 'react';
import css from './css.module.less';

const SelectWithDelete = (props) => {
  const { optionsList, onDelete, value, onChange, disabledDelete, disabled } =
    props;

  return (
    <div className={css.selectWithDelete}>
      <Select
        showSearch
        optionsList={optionsList}
        value={value}
        filterOption={(input, option) =>
          option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
        suffixIcon={<Icon type='icondown' />}
        onChange={onChange}
        size='large'
        disabled={disabled}
      />
      <Icon
        onClick={() => !disabledDelete && onDelete()}
        className={disabledDelete ? css.disabledDelete : css.deleteIcon}
        type='icondelete1'
      />
    </div>
  );
};

export default SelectWithDelete;
